import React from 'react';
import { createComponent } from '@workday/canvas-kit-react/common';
import { Hyperlink } from '@workday/canvas-kit-react/button';
export const ToastLink = createComponent('a')({
    displayName: 'Toast.Link',
    Component: ({ children, href, ...elemProps }, ref, Element) => {
        return (React.createElement(Hyperlink, Object.assign({ ref: ref, href: href, as: Element }, elemProps), children));
    },
});
